import axios from 'axios';

axios.defaults.baseURL = 'https://api.alphavisum.com';

export default axios;